import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableHeader from './InvoiceTableHeader'
import InvoiceTableRow from './InvoiceTableRow'
import InvoiceTableBlankSpace from './InvoiceTableBlankSpace'
import InvoiceTableFooter from './InvoiceTableFooter'

const tableRowsCount = 11;

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderColor: 'black'
  },
});

const InvoiceItemsTable = ({ invoice }) => {
  var net_amount=0
  var balance_due=0

  console.log(invoice)
  invoice.map((i)=>{
    net_amount=net_amount+i.payable_value
    balance_due=balance_due+i.balance_due
  })

 return <View style={styles.tableContainer}>
    <InvoiceTableRow items={invoice} />
    <View style={{
      flexDirection: 'row',
      alignItems: 'center',
      width: "100%",
      height: 20,
      fontSize: 9,
      marginTop:10,
      fontStyle: 'bold'
    }} key={"221"}>
      <Text style={{

        width: '55%',
        textAlign: 'left',
        height: '100%',
        
        fontSize: 9,
      }}>

      </Text>
      <Text style={{

        width: '30%',
        textAlign: 'left',
        borderColor: 'black',
        borderWidth: 0.5,
        height: '100%',
        fontSize: 9,
        paddingLeft:5,
        paddingTop:5


      }}>{"Total Payable Value"}</Text>
      <Text style={{

        width: '15%',
        height: '100%',
        textAlign: 'right',
        borderColor: 'black',
        borderWidth: 0.5,
        backgroundColor: "#eeeeee",
        fontSize:9 ,
        borderRightWidth: 1,
        paddingTop:5,
        paddingRight:5
        
      }}>{net_amount.toFixed(2)+" Rs/-"}</Text>

    </View>
    <View style={{
      flexDirection: 'row',
      alignItems: 'center',
      width: "100%",
      height: 20,
      fontSize: 9,
      fontStyle: 'bold'
    }} key={"221"}>
      <Text style={{

        width: '55%',
        textAlign: 'left',
        height: '100%',
        
        fontSize: 9,
      }}>

      </Text>
      <Text style={{

        width: '30%',
        textAlign: 'left',
        borderColor: 'black',
        borderWidth: 0.5,
        height: '100%',
        paddingLeft:5,
        paddingTop:5,
        fontSize: 9,
        


      }}>{"Total Received Value"}</Text>
      <Text style={{

        width: '15%',
        height: '100%',
        textAlign: 'right',
        borderColor: 'black',
        borderWidth: 0.5,
        backgroundColor: "#eeeeee",
        fontSize: 9,
        borderRightWidth: 1,
        paddingTop:5,
        paddingRight:5
        

      }}>{(net_amount - balance_due).toFixed(2)+" Rs/-"}</Text>

    </View>
    <View style={{
      flexDirection: 'row',
      alignItems: 'center',
      width: "100%",
      height: 20,
      fontSize: 9,
      fontStyle: 'bold'
    }} key={"221"}>
      <Text style={{

        width: '55%',
        textAlign: 'left',
        height: '100%',
        
        fontSize: 9,
      }}>

      </Text>
      <Text style={{

        width: '30%',
        textAlign: 'left',
        borderColor: 'black',
        borderWidth: 0.5,
        height: '100%',
        paddingLeft:5,
        paddingTop:5,
        fontSize: 9,
        


      }}>{"Total Balance Value"}</Text>
      <Text style={{

        width: '15%',
        height: '100%',
        textAlign: 'right',
        borderColor: 'black',
        borderWidth: 0.5,
        backgroundColor: "#eeeeee",
        fontSize: 9,
        borderRightWidth: 1,
        paddingTop:5,
        paddingRight:5
        

      }}>{balance_due.toFixed(2)+" Rs/-"}</Text>

    </View>
   
  </View>
}

export default InvoiceItemsTable